// extracted by mini-css-extract-plugin
module.exports = {"categoryButton":"ArticleCategoryButton_categoryButton__2Pn3j","darkTheme":"ArticleCategoryButton_darkTheme__dd9vW","russianVersion":"ArticleCategoryButton_russianVersion__NQsa3"};